import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root',
})
export class WorkContext {
  get currentUser() {
    return this.authService.currentUser;
  }

  constructor(private authService: AuthService) {}
}
